/* SANTO cards: shredded sold-out, low-stock badge */
(function () {
  'use strict';
  var d = document, html = d.documentElement, LOW = 5, SS = 'santo-stock:';

  /* sharp cards removed (Luca 2026-09-28) */
  function mountToggle() {}
  html.classList.remove('santo-sharp');

  /* ---- stock data ---- */
  var queue = [], active = 0, MAX = 3, pending = {};
  function cacheGet(h) { try { var r = sessionStorage.getItem(SS + h); return r ? JSON.parse(r) : null; } catch (e) { return null; } }
  function cacheSet(h, v) { try { sessionStorage.setItem(SS + h, JSON.stringify(v)); } catch (e) {} }
  function pump() {
    while (active < MAX && queue.length) {
      (function (h) {
        active++;
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'products/' + encodeURIComponent(h) + '?view=stock', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
          .then(function (j) { var v = j && typeof j.total === 'number' ? j : { none: 1 }; cacheSet(h, v); (pending[h] || []).forEach(function (cb) { cb(v); }); delete pending[h]; active--; pump(); });
      })(queue.shift());
    }
  }
  function getStock(h, cb) {
    var c = cacheGet(h); if (c) return cb(c);
    if (pending[h]) return pending[h].push(cb);
    pending[h] = [cb]; queue.push(h); pump();
  }
  function isLow(s) { return s && !s.none && s.tracked && !s.continue && s.total > 0 && s.total <= LOW; }
  function lowText(n) { return 'ONLY ' + n + ' LEFT'; }

  /* ---- cards ---- */
  var CARD = '.card-wrapper, .glfs-drop-grid .card, [class*="glfs-drop"] [class*="card"]:not([class*="card__"]):not([class*="card-"])';
  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]'); if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null;
  }
  function mediaOf(card) { return card.querySelector('.card__media, .media, [class*="image"] , img'); }
  function soldOutDom(card) {
    var t = card.querySelectorAll('.badge, [class*="sold"], button[disabled], [name="add"][disabled]');
    for (var i = 0; i < t.length; i++) {
      var s = (t[i].textContent || '').trim().toLowerCase();
      if (t[i].disabled && /sold|unavailable/.test(s)) return true;
      if (/sold out|esaurito|sold-out/.test(s)) return true;
    }
    return false;
  }
  function shred(card) {
    if (card.classList.contains('santo-shredded')) return;
    card.classList.add('santo-shredded');
    var host = card.querySelector('.card__inner') || card.querySelector('.card__media') || mediaOf(card);
    if (host && host.tagName === 'IMG') host = host.parentElement;
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.classList.add('santo-shred-host');
    var o = d.createElement('span'); o.className = 'santo-shred-overlay'; o.setAttribute('aria-hidden', 'true');
    var st = d.createElement('span'); st.className = 'santo-stamp'; st.textContent = 'SHREDDED';
    host.appendChild(o); host.appendChild(st);
  }
  function lowBadge(card, n) {
    if (card.querySelector('.santo-low')) return;
    var host = card.querySelector('.card__inner') || card.querySelector('.card__media') || mediaOf(card);
    if (host && host.tagName === 'IMG') host = host.parentElement;
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var b = d.createElement('span'); b.className = 'santo-low'; b.textContent = lowText(n); host.appendChild(b);
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); fetchFor(e.target); } });
  }, { rootMargin: '300px' }) : null;
  function fetchFor(card) {
    var h = handleOf(card); if (!h) return;
    getStock(h, function (s) {
      if (s && !s.none && s.available === false) shred(card);
      else if (isLow(s)) lowBadge(card, s.total);
    });
  }
  function process(card) {
    if (card.__santo) return; card.__santo = 1;
    if (card.parentElement && card.parentElement.closest(CARD)) return;
    card.classList.add('santo-card');
    if (soldOutDom(card)) { shred(card); return; }
    if (io) io.observe(card); else fetchFor(card);
  }
  function scan(root) { (root || d).querySelectorAll(CARD).forEach(process); }

  /* ---- PDP low stock ---- */
  function pdp() {
    if (!/\/products\//.test(location.pathname) || d.querySelector('.santo-low-pdp')) return;
    var m = location.pathname.match(/\/products\/([^/?#]+)/); if (!m) return;
    getStock(decodeURIComponent(m[1]), function (s) {
      if (!isLow(s)) return;
      var anchor = d.querySelector('.product__info-container .price__container, .product__info-container [id^="price-"], .product-form__buttons');
      if (!anchor || d.querySelector('.santo-low-pdp')) return;
      var b = d.createElement('div'); b.className = 'santo-low santo-low-pdp'; b.textContent = lowText(s.total);
      anchor.parentNode.insertBefore(b, anchor.nextSibling);
    });
  }

  function init() {
    mountToggle(); scan(); pdp();
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { scan(); }, 120); })
      .observe(d.body, { childList: true, subtree: true });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();